<div class="container-fluid h-100 red">
  <router-outlet></router-outlet>
</div>
